import _ from "lodash";
import { useState } from "react";

const useAPIs = () => {
  const [apiError, setError] = useState(null);
  const [processing, setProcessing] = useState(false);

  const handleError = (error, onFailure) => {
    setProcessing(false);
    onFailure && onFailure(error);
    console.log(error);
    setError(error);
  };

  const handleCatch = (error, onFailure) => {
    setProcessing(false);
    onFailure && onFailure(error);
    console.log("In catch");
    console.log(error);
    setError(error);
  };

  const postData = async (url, inputData, onSuccess, onFailure) => {
    try {
      setError(null);
      setProcessing(true);
      await fetch(process.env.REACT_APP_BASE_URL.concat(url), {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "x-auth": sessionStorage.getItem("x-auth"),
        },
        body: JSON.stringify(inputData ?? {}),
      })
        .then((res) => {
          return res.json().then((data) => ({ response: res, data }));
        })
        .then(({ response, data }) => {
          setProcessing(false);

          // Access the specific response header
          const xAuthHeader = response.headers.get("x-auth");
          if (xAuthHeader) {
            sessionStorage.setItem("x-auth", xAuthHeader);
          }
          if (data.status === 200) {
            onSuccess && onSuccess(data.data, data);
          } else {
            handleError(data?.message, onFailure, response);
          }
        })
        .catch((error) => {
          handleError(error, onFailure);
        });
    } catch (error) {
      handleCatch(error, onFailure);
    }
  };

  const postFormData = (url, inputData, onSuccess, onFailure) => {
    try {
      setError(null);
      setProcessing(true);
      fetch(process.env.REACT_APP_BASE_URL.concat(url), {
        method: "POST",
        headers: {
          "x-auth": sessionStorage.getItem("x-auth"),
        },
        body: inputData,
      })
        .then((res) => res.json())
        .then((data) => {
          setProcessing(false);
          if (data.status === 200) {
            onSuccess && onSuccess(data.data);
            return;
          } else {
            handleError(data?.message, onFailure);
            return;
          }
        })
        .catch((error) => {
          handleError(error, onFailure);
        });
    } catch (error) {
      handleCatch(error, onFailure);
    }
  };

  const getData = (url, onSuccess, onFailure) => {
    try {
      setError(null);
      setProcessing(true);
      fetch(process.env.REACT_APP_BASE_URL.concat(url), {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "x-auth": sessionStorage.getItem("x-auth"),
        },
      })
        .then((res) => res.json())
        .then((data) => {
          setProcessing(false);
          if (data.status === 200) {
            onSuccess && onSuccess(data.data);
            return;
          } else {
            handleError(data?.message, onFailure);
            return;
          }
        })
        .catch((error) => {
          handleError(error, onFailure);
        });
    } catch (error) {
      handleCatch(error, onFailure);
    }
  };

  const getExternalData = (url, onSuccess, onFailure) => {
    try {
      setError(null);
      setProcessing(true);
      fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json; charset=utf-8",
          "Access-Control-Allow-Headers": "Authorization, Content-Type",
          "Access-Control-Allow-Origin": "*",
        },
        mode: "cors",
      })
        .then((res) => res.json())
        .then((data) => {
          setProcessing(false);
          if (data && data.status === 200) {
            onSuccess && onSuccess(data.data);
            return;
          } else {
            handleError(data?.message, onFailure);
            return;
          }
        })
        .catch((error) => {
          handleError(error, onFailure);
        });
    } catch (error) {
      handleCatch(error, onFailure);
    }
  };

  return {
    apiError,
    processing,
    postData,
    postFormData,
    getData,
    getExternalData,
  };
};

export default useAPIs;
